<footer>
	<div [innerHTML]="text" class="text"></div>
    <div id="icpPsbDiv" *ngIf="icpPsbVisible" class="icp-psb">
        <a id="icpDiv" class="icp" target="_blank" href="https://beian.miit.gov.cn/#/Integrated/index" rel="noopener">
            <p>蜀ICP备20007905号-4</p>
        </a>
        <div id="psbDiv" class="psb">
            <a id="psbLink" target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=51019002003549">
                <img src="/assets/images/psb_icon.png"/>
                <p>川公网安备 51019002003549号</p>
            </a>
        </div>
    </div>
</footer>